import React from "react";
import { Route, Routes } from "react-router-dom";
import HomePage from "../pages/HomePage";
import IntroductionPage from "../pages/IntroductionPage";
import ContactPage from "../pages/ContactPage";
import UndergraduatePage from "../pages/UndergraduatePage";
import GraduatePage from "../pages/GraduatePage";
import CommunityFacultyPage from "../pages/CommunityFacultyPage";
import CommunityUniversityPage from "../pages/CommunityUniversityPage";
import ApplicationListPage from "../pages/ApplicationListPage";
import ContactListPage from "../pages/ContactListPage";
import SubscriptionListPage from "../pages/SubscriptionListPage";
import AnnouncementPage from "../components/AnnouncementPage";
import ApplicationPage from "../pages/ApplicationPage";
// import EmployeeApplicationPage from "../pages/EmployeeApplicationPage";
import ApplicationSuccessPage from "../pages/ApplicationSuccessPage";
import CoursePage from "../pages/CoursePage";
import PageNotFound from "../pages/PageNotFound";
import VacanciesPage from "../pages/VacanciesPage";
import AcademicVacanciesPage from "../pages/AcademicVacanciesPage";
import AdvisorsPage from "../pages/AdvisorsPage";
import FaqPage from "../pages/FaqPage";
import ApplicationClosed from "../pages/ApplicationClosed";
import SASTApplicationPage from "../pages/SASTApplicationListPage";
import NewsPage from "../pages/NewsPage";
import NewsDetailPage from "../pages/NewsDetailPage";
import EventsPage from "../pages/EventsPage";
import EventsDetailPage from "../pages/EventsDetailPage";
import SearchPage from "../pages/SearchPage";

const Main = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/about" element={<IntroductionPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/sast" element={<UndergraduatePage />} />
      <Route path="/mpp" element={<GraduatePage />} />
      <Route path="/application-form" element={<ApplicationPage />} />
      <Route path="/application-success" element={<ApplicationSuccessPage />} />
      {/* <Route
        path="/employee-application-form"
        element={<EmployeeApplicationPage />}
      /> */}
      <Route
        path="/employee-application-form"
        element={<ApplicationClosed />}
      />
      <Route path="/application-list" element={<ApplicationListPage />} />
      <Route path="/sast-application-list" element={<SASTApplicationPage />} />
      <Route path="/contact-list" element={<ContactListPage />} />
      <Route path="/subscription-list" element={<SubscriptionListPage />} />
      <Route path="/community-faculty" element={<CommunityFacultyPage />} />
      <Route
        path="/community-university"
        element={<CommunityUniversityPage />}
      />
      <Route path="/announcement/:title" element={<AnnouncementPage />} />
      <Route path="/sast/:program/:course" element={<CoursePage />} />
      <Route path="/vacancy" element={<VacanciesPage />} />
      <Route path="/admin-vacancies" element={<VacanciesPage />} />
      <Route path="/academic-vacancies" element={<AcademicVacanciesPage />} />
      <Route path="/advisors" element={<AdvisorsPage />} />
      <Route path="/news" element={<NewsPage />} />
      <Route path="/news-detail" element={<NewsDetailPage />} />
      <Route path="/events" element={<EventsPage />} />
      <Route path="/events-detail" element={<EventsDetailPage />} />
      <Route path="/search" element={<SearchPage />} />
      <Route path="/faqs" element={<FaqPage />} />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default Main;
